/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetCpoGradeResponse } from '../models/ApiResponseGetCpoGradeResponse';
import type { ApiResponseGetDtcResponse } from '../models/ApiResponseGetDtcResponse';
import type { ApiResponseGetInspectionListResponse } from '../models/ApiResponseGetInspectionListResponse';
import type { ApiResponseGetMaintenanceHistoryResponse } from '../models/ApiResponseGetMaintenanceHistoryResponse';
import type { ApiResponseGetRecallInfoResponse } from '../models/ApiResponseGetRecallInfoResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CpoService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 리콜 정보 조회
   * 정비 이력을 조회합니다.
   * @returns ApiResponseGetRecallInfoResponse OK
   * @throws ApiError
   */
  public getRecallInfoList({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseGetRecallInfoResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cpo/status/recall-info/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 리콜 정보 조회
   * 정비 이력을 조회합니다.
   * @returns ApiResponseGetRecallInfoResponse OK
   * @throws ApiError
   */
  public getRecallInfoList1({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseGetRecallInfoResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cpo/status/recall-info',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 정비 이력 조회
   * 정비 이력을 조회합니다.
   * @returns ApiResponseGetMaintenanceHistoryResponse OK
   * @throws ApiError
   */
  public getMaintenanceHistory({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseGetMaintenanceHistoryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cpo/status/maintenance-history/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 정비 이력 조회
   * 정비 이력을 조회합니다.
   * @returns ApiResponseGetMaintenanceHistoryResponse OK
   * @throws ApiError
   */
  public getMaintenanceHistory1({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseGetMaintenanceHistoryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cpo/status/maintenance-history',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 정기 점검 조회
   * 회차별 정기 점검 상태를 조회합니다.
   * @returns ApiResponseGetInspectionListResponse OK
   * @throws ApiError
   */
  public getInspectionList({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseGetInspectionListResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cpo/status/inspections/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 정기 점검 조회
   * 회차별 정기 점검 상태를 조회합니다.
   * @returns ApiResponseGetInspectionListResponse OK
   * @throws ApiError
   */
  public getInspectionList1({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseGetInspectionListResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cpo/status/inspections',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * DTC 조회
   * DTC 정보를 조회합니다.
   * @returns ApiResponseGetDtcResponse OK
   * @throws ApiError
   */
  public getDtcList({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseGetDtcResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cpo/status/dtc/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * DTC 조회
   * DTC 정보를 조회합니다.
   * @returns ApiResponseGetDtcResponse OK
   * @throws ApiError
   */
  public getDtcList1({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseGetDtcResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cpo/status/dtc',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 종합 인증 등급 조회
   * 종합 인증 등급을 조회합니다.
   * @returns ApiResponseGetCpoGradeResponse OK
   * @throws ApiError
   */
  public getCpoGrade({
    authorization,
    vin,
    puid,
  }: {
    authorization?: string,
    vin: string,
    puid: string,
  }): CancelablePromise<ApiResponseGetCpoGradeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cpo/grade',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 종합 인증 등급 조회
   * 종합 인증 등급을 조회합니다.
   * @returns ApiResponseGetCpoGradeResponse OK
   * @throws ApiError
   */
  public getCpoGrade1({
    authorization,
    vin,
    puid,
  }: {
    authorization?: string,
    vin: string,
    puid: string,
  }): CancelablePromise<ApiResponseGetCpoGradeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cpo/grade/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
}
